export const RECENT_FAQ_KEY = "licensehub.help.recentFaq";
export const FAQ_FEEDBACK_KEY = "licensehub.help.faqFeedback";
export const RECENT_FAQ_LIMIT = 5;

export type FaqFeedback = "helpful" | "notHelpful";

/** Reads the recently-viewed FAQ keys from local storage (most recent first). */
export function readRecentFaqKeys(): string[] {
  try {
    const raw = window.localStorage.getItem(RECENT_FAQ_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((key): key is string => typeof key === "string").slice(0, RECENT_FAQ_LIMIT);
  } catch {
    return [];
  }
}

/** Persists the recently-viewed FAQ keys; ignores storage failures silently. */
export function writeRecentFaqKeys(keys: string[]): void {
  try {
    window.localStorage.setItem(RECENT_FAQ_KEY, JSON.stringify(keys.slice(0, RECENT_FAQ_LIMIT)));
  } catch {
    /* storage unavailable, ignore */
  }
}

/** Reads the lightweight FAQ feedback map (qKey -> helpful / notHelpful). */
export function readFaqFeedback(): Record<string, FaqFeedback> {
  try {
    const raw = window.localStorage.getItem(FAQ_FEEDBACK_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return {};
    const result: Record<string, FaqFeedback> = {};
    Object.entries(parsed).forEach(([key, value]) => {
      if (value === "helpful" || value === "notHelpful") result[key] = value;
    });
    return result;
  } catch {
    return {};
  }
}

/** Persists the FAQ feedback map; ignores storage failures silently. */
export function writeFaqFeedback(map: Record<string, FaqFeedback>): void {
  try {
    window.localStorage.setItem(FAQ_FEEDBACK_KEY, JSON.stringify(map));
  } catch {
    /* storage unavailable, ignore */
  }
}